<div style="display: flex; align-items: center" matSnackBarLabel>
  <mat-icon>{{data.icon}}</mat-icon>
  &nbsp;
  {{data.message}}
</div>
<span *ngIf="data.action" matSnackBarActions>
  <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">
    {{data.action}}
  </button>
</span>

